import React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { COLORS } from "../../../assets/constants/styles";

export const LoadingIndicator = ({ message }) => {
  const { t } = useTranslation();
  return (
    <Container>
      <LoaderAnimation />
      <LoadingText>{message || t("common.loading")}</LoadingText>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  padding: 2rem;
  width: 100%;
`;

const LoaderAnimation = styled.div`
  border: 4px solid ${COLORS.lightGrey};
  border-radius: 50%;
  border-top: 4px solid ${COLORS.violet};
  width: 24px;
  height: 24px;
  animation: spin 1s linear infinite;

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

const LoadingText = styled.div`
  color: ${COLORS.grey};
  font-size: 1rem;
`;
